module.exports = __webpack_public_path__ + "img/btg.cab8d3ee.png";